import { IdentData } from '../../redux/features/dataStorage.redux';
import { axiosWithToken } from '../index';

const { REACT_APP_API_GATEWAY, REACT_APP_BACKEND_BRAND } = process.env;

export interface DashboardIdentPrepareRequest {
  offerId: string;
  customerRole: string;
  identData: IdentData;
  creditApplicationId: string;
  applicantCreditScoreId: string;
  applicantCreditScoreIdCoCustomer?: string;
  isSignatory?: boolean;
}

export interface DashboardIdentPrepareResponse {
  dataStorageId: string;
}

export const prepareDashboardIdent = async (
  params: DashboardIdentPrepareRequest
): Promise<DashboardIdentPrepareResponse> => {
  const url = `${REACT_APP_API_GATEWAY}/ident/${REACT_APP_BACKEND_BRAND}/dashboard/prepare`;

  return axiosWithToken
    .post(url, params)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};
